import moment from 'moment'
export class ValidateService {
    public static titleize (text: string): string {
      const words = text.trim().replace(/\s+/g, ' ').toLowerCase().split(' ')
      const titleizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1))

      return titleizedWords.join(' ')
    }

    public static isValidCpf (cpf: string): boolean {
      return ValidateService.checkCpf(cpf.replace(/[^\d]+/g, ''))
    }

    public static isValidCnpj (cnpj: string): boolean {
      return ValidateService.checkCnpj(cnpj.replace(/[^\d]+/g, ''))
    }

    private static checkCpf (strCpf: string): boolean {
      let sum: number
      let rest: number
      sum = 0

      if (strCpf.length !== 11 ||
        strCpf === '00000000000' ||
        strCpf === '11111111111' ||
        strCpf === '22222222222' ||
        strCpf === '33333333333' ||
        strCpf === '44444444444' ||
        strCpf === '55555555555' ||
        strCpf === '66666666666' ||
        strCpf === '77777777777' ||
        strCpf === '88888888888' ||
        strCpf === '99999999999') return false

      for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(strCpf.substring(i - 1, i)) * (11 - i)
      }
      rest = (sum * 10) % 11

      if ((rest === 10) || (rest === 11)) rest = 0
      if (rest !== parseInt(strCpf.substring(9, 10))) return false

      sum = 0

      for (let i = 1; i <= 10; i++) sum = sum + parseInt(strCpf.substring(i - 1, i)) * (12 - i)
      rest = (sum * 10) % 11

      if ((rest === 10) || (rest === 11)) rest = 0
      if (rest !== parseInt(strCpf.substring(10, 11))) return false

      return true
    }

    private static checkCnpj (strCnpj: string): boolean {
      let sum: number
      let rest: number
      let pos: number

      if (strCnpj.length !== 14 ||
        strCnpj === '00000000000000' ||
        strCnpj === '11111111111111' ||
        strCnpj === '22222222222222' ||
        strCnpj === '33333333333333' ||
        strCnpj === '44444444444444' ||
        strCnpj === '55555555555555' ||
        strCnpj === '66666666666666' ||
        strCnpj === '77777777777777' ||
        strCnpj === '88888888888888' ||
        strCnpj === '99999999999999') return false

      let tamanho = strCnpj.length - 2
      let numeros = strCnpj.substring(0, tamanho)
      const digitos = strCnpj.substring(tamanho)
      sum = 0
      pos = tamanho - 7

      for (let i = tamanho; i >= 1; i--) {
        sum += parseInt(numeros.charAt(tamanho - i)) * pos--
        if (pos < 2) pos = 9
      }
      rest = (sum % 11) < 2 ? 0 : 11 - (sum % 11)
      if (rest !== parseInt(digitos.charAt(0))) return false

      tamanho = tamanho + 1
      numeros = strCnpj.substring(0, tamanho)
      sum = 0
      pos = tamanho - 7

      for (let i = tamanho; i >= 1; i--) {
        sum += parseInt(numeros.charAt(tamanho - i)) * pos--
        if (pos < 2) pos = 9
      }
      rest = (sum % 11) < 2 ? 0 : 11 - (sum % 11)
      if (rest !== parseInt(digitos.charAt(1))) return false

      return true
    }
}
